/***************************************************************************/
"use client";
/***************************************************************************/

import { AirFiLogo } from "@/client/components/airfi-logo";
import { Flex } from "@/client/components/ui/flex";

const Loader: React.FC = () => {
  return (
    <div className="bg-gray-200 h-1.5 overflow-hidden relative rounded w-[120px]">
      <div className="animate-loading-indicator-slider duration-2000 rounded h-1.5 w-1/3 bg-gray-900 dark:bg-gray-600" />
    </div>
  );
};

const PageLoading: React.FC = () => {
  return (
    <Flex
      direction="vertical"
      justify-content="center"
      align-items="center"
      gap="normal"
      className="h-screen text-gray-500"
    >
      <AirFiLogo className="h-10" />
      <Loader />
    </Flex>
  );
};

export default PageLoading;
